import * as React from "react";

export type PortalContextProps = {
  container: React.RefObject<HTMLElement | null>;
};

export const defaultPortalContextProps = {
  container: { current: null },
};

export const PortalContext = React.createContext<PortalContextProps>(
  defaultPortalContextProps,
);
